import { forwardRef, createElement } from 'react';

function IconBook(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M17 4.5c1.583 0 3.165.45 4.748 1.352a.5.5 0 01.252.435V19.15a.5.5 0 01-.728.445C19.848 18.865 18.424 18.5 17 18.5c-1.667 0-3.333.5-5 1.5-1.667-1-3.333-1.5-5-1.5-1.424 0-2.848.365-4.272 1.095A.5.5 0 012 19.15V6.287a.5.5 0 01.252-.435C3.835 4.951 5.417 4.5 7 4.5c1.667 0 3.333.5 5 1.5 1.667-1 3.333-1.5 5-1.5zM17 6c-1.284 0-2.586.363-3.92 1.108l-.308.178L12 7.75l-.772-.463C9.786 6.421 8.383 6 7 6c-1.11 0-2.232.271-3.378.825l-.122.062v10.739l.056-.02a10.363 10.363 0 013.059-.598L7 17c1.585 0 3.156.382 4.704 1.134l.296.149.296-.149c1.429-.694 2.878-1.073 4.339-1.127L17 17c1.027 0 2.05.16 3.065.48l.435.147V6.887l-.122-.062c-1.041-.504-2.064-.773-3.075-.818L17 6zm0 7.75c.836 0 1.669.115 2.5.344v1.567a7.98 7.98 0 00-2.5-.411c-1.16 0-2.325.266-3.501.804v-1.627A9.628 9.628 0 0117 13.75zm0-3c.836 0 1.669.115 2.5.344v1.567a7.98 7.98 0 00-2.5-.411c-1.16 0-2.325.266-3.501.804v-1.627A9.628 9.628 0 0117 10.75zm0-3c.836 0 1.669.115 2.5.344v1.567A7.98 7.98 0 0017 9.25c-1.16 0-2.325.266-3.501.804V8.427A9.628 9.628 0 0117 7.75z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Book = /*#__PURE__*/forwardRef(IconBook);

export default Book;
//# sourceMappingURL=Book.js.map
